// src/api/authApi.js
import api from "./axios";

/** ---------------- Legacy email/password sign-in (keep while migrating) ---------------- */
export async function signInApi({ email, password }) {
  const { data } = await api.post("/api/users/signin", { email, password });
  // expected: { message, email, token }
  return data;
}

export async function signOutApi() {
  try {
    await api.post("/api/users/signout");
  } catch (_) {
    /* ignore */
  }
}

/** ---------------- Current user (new should return id/phone/email/userName/role) ---------------- */
export async function currentUserApi() {
  const { data } = await api.get("/api/users/current-user");
  return data;
}

/** ---------------- New OTP auth ----------------
 * IMPORTANT:
 * If your axios instance has default Authorization set,
 * OTP endpoints should still be PUBLIC.
 * We override Authorization per-request to avoid accidental 401 from strict filters.
 */
export async function userRequestOtpApi({ phoneNumber }) {
  const { data } = await api.post(
    "/api/users/auth/otp/request",
    { phoneNumber },
    { headers: { Authorization: "" } } // ✅ force “no auth” for public endpoint
  );
  return data;
}

export async function userVerifyOtpApi(body) {
  const { data } = await api.post(
    "/api/users/auth/otp/verify",
    body,
    { headers: { Authorization: "" } } // ✅ public
  );
  // expected: { token, isNewUser, user?, message? }
  return data;
}

export async function userCompleteProfileApi(payload) {
  const { data } = await api.post("/api/users/auth/profile/complete", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
}

/** ---------------- Legacy signup (optional) ---------------- */
export async function signUpApi(payload) {
  const { data } = await api.post("/api/users/save", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
}
